// extracted by mini-css-extract-plugin
module.exports = {"numberWrapper":"_1d2c2fc"};